import "./index.scss";

type Props = {
  icon?: string;
  name?: string;
};

const UserInfo = ({ icon, name }: Props) => {
  return (
    <div id="user-info-top">
      <div className="user-info-container">
        <div className="user-info-avatar">
          <i className="fa-solid fa-user"></i>
        </div>{" "}
        <div className="user-info-name">{name}</div>
      </div>
    </div>
  );
};

export default UserInfo;
